import { Radio, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { Sale } from "../../../../api/sales";
import { useState, Dispatch, SetStateAction, useEffect } from "react";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";
import { format } from "date-fns";

interface Props {
  sales: Sale[] | undefined;
  SaleLoading: boolean;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  setSales: Dispatch<SetStateAction<Sale[] | undefined>>;
  setSelectedInvoice: Dispatch<SetStateAction<any>>;
  selectedInvoice: any;
  search: string;
  tableKey: string;
  sessionId: string;
  SaleMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      session: string | number | undefined;
      limit: number;
      isPaid?: boolean | undefined;
      q: string;
    },
    unknown
  >;
}

const HistoryList = ({
  sales,
  SaleLoading,
  page,
  setPage,
  setSales,
  setSelectedInvoice,
  selectedInvoice,
  search,
  tableKey,
  SaleMutation,
  sessionId,
}: Props) => {
  const { t } = useTranslation("common");

  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      SaleMutation({
        session: sessionId,
        limit: page * 10 + 10,
        q: search,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);

        setSales(res.data.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: {}[] = [
    {
      title: `${t("invoice")}`,
      dataIndex: "invoiceNo",
      width: "20%",
      key: "invoiceNo",
      className: "table-header main",
      render: (record: any) => {
        return <>{record || "0000"}</>;
      },
    },
    {
      title: `${t("customer")}`,
      dataIndex: "customer",
      key: "customer",
      className: "table-row main",
      render: (record: any) => {
        return <>{record?.name}</>;
      },
      width: "20%",
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      className: "table-row main",
      width: "20%",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("total-price")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "20%",
      className: "table-row main"
    },
    {
      title: `${t("status")}`,
      align: "center",
      dataIndex: "isPaid",
      key: "isPaid",
      className: "table-row main",
      render: (record: any) =>
        record ? (
          <Tag className="active">{t('paid')}</Tag>
        ) : (
          <Tag className="inactive">{t('unpaid')}</Tag>
        ),
      width: "20%",
    },
    {
      title: `${t("select")}`,
      key: "action",
      width: "5rem",
      align: "center",
      className: "table-row main",
      render: (record: any) => (
        <div>
          <Radio.Group
            name="sales"
            onChange={(e) => setSelectedInvoice(e.target.value)}
            value={selectedInvoice}
          >
            <Radio value={record.id} />
          </Radio.Group>
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={sales}
        className="bill"
        loading={SaleLoading}
        pagination={{ pageSize: 5 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setSelectedInvoice(record.id);
            },
          };
        }}
      />
    </>
  );
};

export default HistoryList;
